<template>
  <div id="app">

    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
const defaultLayout = 'no-sidebar'
export default {
  computed: {
    layout () {
      return (this.$route.meta.layout || defaultLayout) + '-layout'
    }
  },
  created () {
    // nothing defined here (when this.$route.path is other than "/")
    // console.log(this.$route, this.$route.meta.layout);
  },
  updated () {
    // something defined here whatever the this.$route.path
    // console.log(this.$route, this.$route.meta.layout);
  }
}
</script>

<style>

.v-date-picker-table .v-btn.v-btn--icon{
  width: 32px;
  height: 32px;
}
.v-date-picker-table .v-btn {
  padding:0px;
}

.v-date-picker-table .v-btn.v-btn--icon {
  position: absolute;
  margin: -15px;
}


</style>
